import { ICurrencyConfig } from "@/config/currency.config";
import eurIcon from "@/icons/currency/eur.svg";
import usdIcon from "@/icons/currency/usd.svg";

// Ukraine-specific currency configuration
const ukraineCurrencyConfig: ICurrencyConfig = {
  currencies: [
    { label: "USD", value: "USD", icon: usdIcon, symbol: "$" },
    { label: "EUR", value: "EUR", icon: eurIcon, symbol: "€" },
  ],
  defaultCurrency: "USD",
};

export default ukraineCurrencyConfig;
